// Imports
import React from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { ArrowRight } from "react-feather"
import { formatMonth, LinkConverter } from "@utils"
import { Link } from "gatsby"

export const NewsCard = ({ title, image, date, link }) => {
  const img = getImage(image.gatsbyImageData)

  return (
    <Link to={`/article/${LinkConverter(title)}`}>
      <div className="news-card">
        <div className="news-card__image">
          <GatsbyImage image={img} alt={title} />
        </div>
        <span> {formatMonth(date)} </span>
        <h5> {title} </h5>
        <div className="news-card__link">
          <p href={link.link}>{link.text}</p>
          <ArrowRight />
        </div>
      </div>
    </Link>
  )
}
